module.exports = __webpack_public_path__ + "static/media/first.707a9821.jpg";